import ControllerStatusIndicator from './component'

export default ControllerStatusIndicator